'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param component
 * @return {Object}
 */
function decorateListItem(component) {
  return _react2.default.createElement(
    'div',
    { className: "dp-ListItemRow" },
    component
  );
}

function renderChildren(children) {

  function map(component) {
    return _react2.default.isValidElement(component) ? decorateListItem(component) : component;
  }

  return _react2.default.Children.map(children, map);
}

var ListItem = function ListItem(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return _react2.default.createElement(
    'div',
    { className: (0, _classnames2.default)("dp-ListItem dp---is-hoverable", className) },
    renderChildren(children)
  );
};

ListItem.propsType = {

  /**
   * any additional classnames to be applied to the AppBar container
   */
  className: _propTypes2.default.string
};

exports.default = ListItem;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-components/lib/List/ListItem.js
// module id = 361
// module chunks = 0